<template>
  <div class="calico-credit-box-scale">
    <div class="scale-point">
      <span
        :class="['point-position', badgeColor, 'label--medium']"
        :style="badgeStyle"
      >
        {{ value }}
      </span>
    </div>

    <div class="scale-line">
      <span class="label--xsmall">Low</span>
      <div class="line" />
      <span class="label--xsmall">Med</span>
      <div class="line" />
      <span class="label--xsmall">High</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalicoCreditBoxScale',
  props: {
    value: { type: String, default: '####' },
    score: { type: Number, default: 1 }
  },
  computed: {
    badgeStyle() {
      const score = this.score

      if (score === 1) return { left: '0px' }
      if (score === 7) return { right: '0px' }

      const positionMap = {
        2: '17%',
        3: '33%',
        4: '50%',
        5: '67%',
        6: '83%'
      }

      return {
        left: positionMap[score] || '0%',
        transform: 'translateX(-50%)'
      }
    },
    badgeColor() {
      const colorMap = {
        1: 'badge-green',
        2: 'badge-cyan',
        3: 'badge-yellow',
        4: 'badge-pink',
        5: 'badge-orange',
        6: 'badge-red',
        7: 'badge-black'
      }

      return colorMap[this.score] || 'badge-black'
    }
  }
}
</script>

<style scoped lang="scss">
.calico-credit-box-scale {

  position: relative;

  .scale-point {
 
    min-height: 26px;

    .point-position {
      position: absolute;
      transition: left 0.2s ease-in-out, right 0.2s ease-in-out;
    }
  }

  .scale-line {
    @include inline-space($space-xxsmall);
    align-items: center;
    width: 100%;

    .line {
      flex: 1;
      height: 1px;
      background-color: $color-neutral-light;
    }

    .label--xsmall {
      color: $color-text-secondary;
    }
  }
}
</style>
